import { useContext, React, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import "./addPlan.css";
import { AddPlanContext } from "../AddPlanView";
import NextIcon from "../../../../assets/images/next-icon.svg";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import Loader from "../../../../components/Loader/Loader";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import Accordion from "@mui/material/Accordion";
// import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ThemeSelect from "../../../../components/ThemeSelectOption/SelectOption";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import CheckedTrial from "../../../../assets/images/checkedBox.svg";
import checkTrial from "../../../../assets/images/check.svg";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const AddPlan = () => {
  const {
    ContentData,
    spinnerStatus,
    planName,
    price,
    maximumUsers,
    billing,
    description,
    features,
    handleName,
    nameValidation,
    validatedName,
    handlePrice,
    billingData,
    priceValidation,
    validationPricing,
    handleMaximumUser,
    validationMaximumUser,
    userValidation,
    handleBillChange,
    validationBilling,
    descriptionValidation,
    handledescription,
    validationDescription,
    addPlanSubmit,
    checkedFeatures,
    handleCheckboxChange,
    trialShow,
    setTrialShow,
    handleTrial,
    trialPeriods,
    successAlertShow,
    successAlertMessage,
    errorAlertShow,
    setErrorAlertShow,
    errorAlertMessage,
    buttonText,
    statusValue,
    planListView,
    goToLogin,
    errorPopup,
    setErrorPopup,
    getFeatureData,
  } = useContext(AddPlanContext);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing">
          {ContentData.planManagement.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.planManagement.addPlan}
        </span>
      </div>
      {spinnerStatus && <Loader />}
      <Container>
        <div className="pageTittles">{ContentData.planManagement.addPlan}</div>
        <form className="planManageSection" onSubmit={addPlanSubmit}>
          <div className="basicContainer">
            <div className="viewAdminSection addAdminSection">
              <Row>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.planManagement.planName}</h4>
                      <InputComponent
                        placeholder={ContentData.planManagement.enterName}
                        value={planName}
                        type={"text"}
                        onChange={handleName}
                        handleBlur={() => nameValidation(planName)}
                      />
                      <p className="mb-0 error-msg">
                        {validatedName ? validatedName : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.planManagement.pricing}</h4>
                      <InputComponent
                        placeholder={ContentData.planManagement.enterPricing}
                        value={price}
                        type={"text"}
                        onChange={handlePrice}
                        handleBlur={() => priceValidation(price)}
                      />
                      <p className="mb-0 error-msg">
                        {validationPricing ? validationPricing : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.planManagement.maximumUsers}</h4>
                      <InputComponent
                        placeholder={
                          ContentData.planManagement.enterMaximumUsers
                        }
                        value={maximumUsers}
                        type={"text"}
                        onChange={handleMaximumUser}
                        handleBlur={() => userValidation(maximumUsers)}
                      />
                      <p className="mb-0 error-msg">
                        {validationMaximumUser ? validationMaximumUser : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="4" lg="4" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.planManagement.billingCycle}</h4>
                      <ThemeSelect
                        selectPlaceholder={"Select"}
                        values={billingData}
                        selectNum={"id"}
                        label={"duration"}
                        handleSelectData={handleBillChange}
                      />
                      <p className="mb-0 error-msg">
                        {validationBilling ? validationBilling : ""}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xl="8" lg="8" sm="12">
                  <div className="adminDetailSection">
                    <div className="adminDetailSectionTop roleSubPage">
                      <h4>{ContentData.planManagement.description}</h4>
                      <InputComponent
                        placeholder={
                          ContentData.planManagement.enterDescription
                        }
                        value={description}
                        type={"text"}
                        onChange={handledescription}
                        handleBlur={() => descriptionValidation(description)}
                      />
                      <p className="mb-0 error-msg">
                        {validationDescription ? validationDescription : ""}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="profileNotificationPreference">
              <Accordion
                className="profileAccordion"
                disableGutters
                elevation={0}
                sx={{
                  border: "none",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{
                    fontSize: "12px",
                    backgroundColor: "#F7F8FA",
                    fontWeight: "bold",
                    color: "#6b7a99",
                  }}
                >
                  {ContentData.planManagement.features}
                </AccordionSummary>

                <AccordionDetails sx={{ padding: 0 }}>
                  <Row className="accordionRowGroup planFeatureSection">
                    {features &&
                      features.map((item, index) => (
                        <Col
                          lg="6"
                          sm="12"
                          key={index}
                          className="accordionRow"
                        >
                          <div className="featuredData">
                            <CheckBox
                              label={item.name}
                              id={item._id}
                              features={item.description}
                              check={checkedFeatures.includes(item._id)} // Set checkbox state
                              onChange={() => handleCheckboxChange(item._id)} // Handle checkbox toggle
                            />
                          </div>
                        </Col>
                      ))}
                  </Row>
                </AccordionDetails>
              </Accordion>
            </div>
            <div className="trialSection">
              <Row>
                <Col sm="4">
                  <div
                    className="trialData"
                    onClick={() => setTrialShow(!trialShow)}
                  >
                    {trialShow ? (
                      <div>
                        <img src={CheckedTrial} alt="" />
                      </div>
                    ) : (
                      <div>
                        <img src={checkTrial} alt="" />
                      </div>
                    )}
                    <span>{ContentData?.planManagement?.trialText}</span>
                  </div>
                  {trialShow && (
                    <div>
                      <ThemeSelect
                        selectPlaceholder={"Select"}
                        values={trialPeriods}
                        selectNum={"id"}
                        label={"duration"}
                        handleSelectData={handleTrial}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <div className="bottomButtons">
            <BorderButton
              value={ContentData.authPage.cancelText}
              onClick={planListView}
            />
            <ThemeButton
              value={ContentData.authPage.submitText}
              id="submitAddPlanBtn"
              type="submit"
            />
          </div>
        </form>
      </Container>
      <PopupAlertError
        status={statusValue}
        show={errorAlertShow}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        handleCancel={() => setErrorAlertShow(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorAlertShow(false);
          } else {
            setErrorAlertShow(false);
            document.getElementById("submitAddPlanBtn").click();
          }
        }}
      />
      <SuccessPopupAlert
        show={successAlertShow}
        alertMessage={successAlertMessage}
        handleSubmit={() => planListView()}
      />
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorAlertMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getFeatureData();
          }
        }}
      />
    </div>
  );
};

export default AddPlan;
